module.exports = __webpack_public_path__ + "img/mini-code.ad782f8b.jpg";